export type AchievementTier =
  | 'common'
  | 'uncommon'
  | 'scarce'
  | 'rare'
  | 'ultra_rare'
  | 'secret';

export interface AchievementTierConfig {
  id: AchievementTier;
  label: string;
  reward: number;
}

export const ACHIEVEMENT_TIERS: Record<AchievementTier, AchievementTierConfig> = {
  common: {
    id: 'common',
    label: 'Common',
    reward: 5,
  },
  uncommon: {
    id: 'uncommon',
    label: 'Uncommon',
    reward: 10,
  },
  scarce: {
    id: 'scarce',
    label: 'Scarce',
    reward: 30,
  },
  rare: {
    id: 'rare',
    label: 'Rare',
    reward: 80,
  },
  ultra_rare: {
    id: 'ultra_rare',
    label: 'Ultra Rare',
    reward: 300,
  },
  secret: {
    id: 'secret',
    label: 'Secret',
    reward: 2000,
  },
};

export interface Achievement {
  id: string;
  name: string;
  description: string;
  tier: AchievementTier;
  symbol: string;
  rewardAmount?: number;
}

